import React from 'react';
import { Map as MapOutlined, LayoutGrid as GridOnOutlined } from 'lucide-react';
import type { SiteExplorerTabs } from 'src/shared/types/siteExplorerTabs';
import styles from './ListMapViewTabs.module.scss';
import Tabs from '../Tabs/Tabs';

type ListMapViewTabsProps = {
    tab: SiteExplorerTabs;
    onTabChange: (tab: SiteExplorerTabs) => void;
    isMapFirst?: boolean;
    disableMap?: boolean;
    disableList?: boolean;
};

const tabs = [
    {
        id: 'map',
        label: (
            <>
                <MapOutlined /> Map view
            </>
        ),
    },
    {
        id: 'list',
        label: (
            <>
                <GridOnOutlined /> List view
            </>
        ),
    },
];

const ListMapViewTabs = (props: ListMapViewTabsProps) => {
    const { tab, onTabChange, isMapFirst, disableList, disableMap } = props;

    const orderedTabs = isMapFirst ? tabs : [...tabs].reverse();

    return (
        <Tabs
            tabs={orderedTabs.map(tab => ({ ...tab, isDisabled: tab.id === 'map' ? disableMap : disableList }))}
            onTabChange={value => onTabChange(value as SiteExplorerTabs)}
            selectedTab={tab}
            classNames={{
                default: styles.tabItem,
                selected: styles.tabItemSelected,
                tabsContainer: styles.tabsContainer,
            }}
        ></Tabs>
    );
};

export default ListMapViewTabs;
